var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningToast = function SvgWarningToast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.47 19h15.06L12 5.99 4.47 19ZM13 18h-2v-2h2v2Zm0-4h-2v-4h2v4Z",
    fill: "#A74200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21h22L12 2 1 21Zm3.47-2L12 5.99 19.53 19H4.47ZM11 16h2v2h-2v-2Zm0-6h2v4h-2v-4Z",
    fill: "#A74200"
  })));
};
export default SvgWarningToast;